﻿
cb.define([], function() {
	var AA_aa_operator_VM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			// //页面加载后判断是否店员，并设置控件状态
			// viewmodel.on('afterLoadData', function(data){
			// 	let isClerkValue = viewmodel.get('isclerk').getValue();
			// 	let isClerk = typeof isClerkValue == 'boolean' ? isClerkValue : (isClerkValue == 'false' ? false : true);
			// 	if(isClerk != null && isClerk != undefined && isClerk != '' && isClerk == true){
			// 		viewmodel.get('isemployee').setDisabled(false);
			// 		viewmodel.get('operatorStore').setState('bIsNull', false);
			// 		viewmodel.get('operatorStore').setDisabled(false);
			// 		viewmodel.get('iSuperior_name').setDisabled(false);
			// 	}
			// 	else{
			// 		viewmodel.get('isemployee').setDisabled(true);
			// 		viewmodel.get('operatorStore').setState('bIsNull', true);
			// 		viewmodel.get('operatorStore').setDisabled(true);
			// 		viewmodel.get('iSuperior_name').setDisabled(true);
			// 	}
			// });
			//选择操作员时，不出超级管理员
			viewmodel.get("cYxyUser_code").on('beforeBrowse', function(data) {
				var condition = {
					"isExtend": true,
					simpleVOs: []
				};
				condition.simpleVOs.push({
					field: 'userType',
					op: 'neq',
					value1: 0
				});
				viewmodel.get("cYxyUser_code").setFilter(condition);
			});
			// //是否店员值修改后
			// viewmodel.get('isclerk').on('afterValueChange', function(data){
			// 	let isClerkValue = viewmodel.get('isclerk').getValue();
			// 	let isClerk = typeof isClerkValue == 'boolean' ? isClerkValue : (isClerkValue == 'false' ? false : true);
			// 	if(isClerk != null && isClerk != undefined && isClerk != '' && isClerk == true){
			// 		viewmodel.get('isemployee').setDisabled(false);
			// 		//viewmodel.get('isemployee').setValue(null);
			// 		viewmodel.get('operatorStore').setDisabled(false);
			// 		viewmodel.get('operatorStore').setState('bIsNull', false);
			// 	}
			// 	else{
			// 		viewmodel.get('isemployee').setDisabled(true);
			// 		viewmodel.get('isemployee').setValue(false);
			// 		viewmodel.get('operatorStore').setDisabled(true);
			// 		viewmodel.get('operatorStore').setState('bIsNull', true);
			// 		let _value = viewmodel.get('operatorStore').getValue()
			// 		_value = _value.map((v,index)=>{
			// 			return index
			// 		})
			// 		viewmodel.get('operatorStore').deleteItems(_value);

			// 		viewmodel.get('iSuperior_name').setDisabled(true);
			// 		// let superior_name = viewmodel.get('iSuperior_name').getValue();
			// 		// superior_name = superior_name.map((v, index) => {
			// 		// 	return index;
			// 		// });
			// 		// viewmodel.get('iSuperior_name').deleteItems(superior_name);
			// 		viewmodel.get('iSuperior_name').setValue(['']);
			// 	}
			// });
			// //先选门店才能选上级
			// viewmodel.get('operatorStore').on('afterValueChange', function(data){
			// 	if(viewmodel.get('operatorStore').getValue().length > 0){
			// 		viewmodel.get('iSuperior_name').setDisabled(false);
			// 	}
			// 	else{
			// 		viewmodel.get('iSuperior_name').setDisabled(true);
			// 	}
			// });
			// viewmodel.get('operatorStore').on('beforeBrowse', function(data){
			// 	let isClerkValue = viewmodel.get('isclerk').getValue();
			// 	let isClerk = typeof isClerkValue == 'boolean' ? isClerkValue : (isClerkValue == 'false' ? false : true);
			// 	if(isClerk != null && isClerk != undefined && isClerk != '' && isClerk == true) {
			// 		viewmodel.get('iSuperior_name').setDisabled(false);
			// 	} else {
			// 		cb.utils.alert("请先选择是否店员！");
			// 		return false;
			// 	}
			// });
			// //避免参照弹出后不选值的情况下直接返回无法触发afterValueChange事件
			// viewmodel.get('operatorStore').on('afterBrowse', function(data){
			// 	if(viewmodel.get('operatorStore').getValue().length > 0){
			// 		viewmodel.get('iSuperior_name').setDisabled(false);
			// 	}
			// 	else{
			// 		viewmodel.get('iSuperior_name').setDisabled(true);
			// 	}
			// });
			// //上级参照必须先选门店
			// viewmodel.get('iSuperior_name').on('beforeBrowse', function(data){
			// 	if(viewmodel.get('operatorStore').getValue().length > 0) {
			// 		viewmodel.get('iSuperior_name').setDisabled(false);
			// 	} else {
			// 		cb.utils.alert("请先选择所属门店！");
			// 		return false;
			// 	}
			// });
		}
	}
	try {
		module.exports = AA_aa_operator_VM_Extend;
	} catch(error) {

	}
	return AA_aa_operator_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_operator_VM.Extend.js